module.exports = __webpack_public_path__ + "static/media/girl-14.f20007d6.svg";